import { getLocalTimeZone } from "@internationalized/date";

import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import { formatDate } from "utils/date";

type ScheduledDateDisplayProps = {
  date: Date;
};

const ScheduledDateDisplay = ({ date }: ScheduledDateDisplayProps) => {
  const localTimezone = getLocalTimeZone();

  const localTime = formatDate({
    date,
    timezone: localTimezone,
  });

  const utcTime = formatDate({
    date,
    timezone: "UTC",
  });

  const showBothTimes = localTime !== utcTime;

  return (
    <Box direction="column" gap="small">
      <Typography tag="p" variant="p-body2">
        {localTime}
      </Typography>
      {showBothTimes && (
        <Typography tag="p" variant="p-body2">
          {utcTime}
        </Typography>
      )}
    </Box>
  );
};

export default ScheduledDateDisplay;
